import type { EventBusKey } from '@vueuse/core'

type DropdownEvent = {
  id: string
  selected: string
}

export const DropdownEventKey: EventBusKey<DropdownEvent> = Symbol()
